<div class="cpr">    
    <div class="cpr-items" #container>        
        <div class="cpr-item" [style.min-width.px]="w" *ngFor="let item of items">
            <cat-item [item]="item" [hoverable]="false" [compact]="true"></cat-item>
        </div>        
    </div>
</div>